import { useState } from "react";

import { Button } from "@/design-system/Button";

import { moveTo, useScopes } from "@/shared/session/scopes";

/**
 * The person's own places side by side: the platform they administer and the
 * accounts they own. Shown only when there is somewhere to switch to.
 */
export function ScopeSwitcher(): React.JSX.Element | null {
  const options = useScopes();
  const [pending, setPending] = useState(false);
  const [refused, setRefused] = useState(false);
  if (options.length < 2) return null;

  return (
    <div className="flex items-center gap-2">
      <div
        role="group"
        aria-label="Где работать"
        className="flex shrink-0 overflow-hidden rounded-md border border-border-strong"
        data-testid="scope-switcher"
      >
        {options.map((option) => (
          <Button
            key={`${option.kind}:${option.tenant_id ?? ""}/${option.account_id ?? ""}`}
            variant="ghost"
            size="sm"
            selected={option.current}
            aria-pressed={option.current}
            disabled={pending || option.current}
            className="rounded-none font-semibold whitespace-nowrap disabled:opacity-100"
            onClick={() => {
              setPending(true);
              setRefused(false);
              void moveTo(option).then((moved) => {
                if (!moved) {
                  setRefused(true);
                  setPending(false);
                }
              });
            }}
          >
            {option.kind === "PLATFORM" ? "Платформа" : option.display_name}
          </Button>
        ))}
      </div>
      {refused && (
        <span role="alert" className="text-helper-sm text-status-negative">
          Не удалось переключиться
        </span>
      )}
    </div>
  );
}
